import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";

const CustomerVechileTabs = ({ data, loading }) => {

  const columns = [
    { field: "manufacturerName", headerName: "Manufacturer" },
    { field: "vehicleRegistrationNo", headerName: "Registration No." },
    { field: "type", headerName: "Type" },
    { field: "vehicleModelName", headerName: "Model" },
    { field: "vehicleVariantName", headerName: "Variant" },
    { field: "year", headerName: "Model Year" },
    { field: "purchased_year", headerName: "Purchased Year" },
    { field: "usage", headerName: "Usage" },
    { field: "iAm", headerName: "I am a" },
  ];

  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading?.isLoading}
      pagination
      localPagination
      page={0}
      rowsPerPage={5}
    />
  );
};

export default withRouter(CustomerVechileTabs);
